let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("g9uqi")).then(() => parcelRequire('aGJF2'));